import { Flex, Text, Box, useColorModeValue } from '@chakra-ui/react'
import CustomImage from '@/components/Image'

export const TestimonialItems = (props: {
  id: number
  pics: string
  title: string
  comment: string
}) => {
  const { id, pics, title, comment } = props

  const bgColor = useColorModeValue('white', 'brand.primary.900')
  return (
    <Flex
      px={{ base: '1.2rem', md: '2rem' }}
      textAlign="center"
      justifyContent="center"
      direction="column"
      bg={bgColor}
      py={4}
      maxW={{ base: '20rem', md: '23.18rem' }}
      m="0 auto"
    >
      <CustomImage
        src="/testimonialSign.svg"
        width="13px"
        height="15px"
        alt="testimony sign"
      />
      <Text mb="0.81rem" fontWeight="regular" fontSize="1.25rem">
        {comment}
      </Text>
      <Box display="flex" alignItems="baseline" justifyContent="center">
        <Box
          mt={2}
          marginBottom="1.13rem"
          border="2px solid "
          color="lineColor"
          width="4.42rem"
        ></Box>
      </Box>

      <CustomImage
        src={pics}
        width={50}
        height={50}
        fill
        mb="0.63rem"
        alt="testominies pictures"
        rounded={100}
      />
      <Text fontWeight="medium" fontSize="0.97rem">
        {title}
      </Text>
    </Flex>
  )
}
